import { connect } from 'react-redux'
import { selectCurrentTicketSearchResultTicketCount } from 'selectors/search/base'
import CountView from 'components/ConversationList/Header/TitleBar/Count'

const select = state => ({
  count: selectCurrentTicketSearchResultTicketCount(state),
})

export default connect(select)(CountView)
